import React from 'react'
import {connect} from 'react-redux'

import { DualRing } from 'react-awesome-spinners'


const Loader = (props) => {

  return (
    <div className={`align-items-center bg-opacity-75 d-flex h-100 justify-content-center position-absolute 
    top-0 w-100 vvz-loader ${typeof props.dark === 'undefined' || !props.dark ? 'bg-white' : 'bg-black'}`}
    >
      <div className="d-inline-block">
        <DualRing
          size={80}
          color={typeof props.dark === 'undefined' || !props.dark ? 'var(--bs-primary)' : '#ffffff'}
        />
      </div>
    </div>
  )

}

const mapDispatchToProps = dispatch => ({})

const mapStateToProps = state => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Loader)
